import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'college',
  pure: true,
})
export class CollegePipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string | null | undefined): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('College not set');
    }
    return this.lookupData.getColleges({
      selectedIds: [String(value)],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const name = result.items.find(c => String(c.id) === String(value))?.name;
        return name ?? 'College not set';
      })
    );
  }
}
